import { ofType } from "redux-observable";
import { of } from "rxjs";
import { map, switchMap, mergeMap, catchError } from "rxjs/operators";
import { getJSON, postJSON, putJSON, deleteJSON } from "../utils/ajaxUtil";
import {
  REQUESTED_USERS,
  REQUESTED_USER_BY_ID,
  REQUESTED_CREATE_USER,
  REQUESTED_UPDATE_USER,
  REQUESTED_DELETE_USER,
  REQUESTED_CURRENT_USER,
  REQUESTED_CURRENT_USER_FAILED,
  REQUESTED_CREATE_USER_FAILED,
  REQUESTED_UPDATE_USER_FAILED,
  receiveUsers,
  receiveUserById,
  receiveCreateUser,
  receiveUpdateUser,
  receiveDeleteUser,
  receiveCurrentUsers,
} from "../redux/actions/userAction";

export const fetchCurrentUsers = (action$) =>
  action$.pipe(
    ofType(REQUESTED_CURRENT_USER),
    map((action) => action.payload),
    switchMap(() =>
      getJSON(`/users/current`).pipe(
        map((res) => receiveCurrentUsers(res.data)),
        catchError((error) =>
          of({
            type: REQUESTED_CURRENT_USER_FAILED,
            payload: error.xhr.response,
            error: true,
          })
        )
      )
    )
  );

export const fetchUsers = (action$) =>
  action$.pipe(
    ofType(REQUESTED_USERS),
    map((action) => action.payload.users),
    switchMap((users) =>
      getJSON(`/users`).pipe(map((res) => receiveUsers(res.data)))
    )
  );

export const fetchUserById = (action$) =>
  action$.pipe(
    ofType(REQUESTED_USER_BY_ID),
    map((action) => action.payload.id),
    switchMap((id) =>
      getJSON(`/users/${id}`).pipe(map((res) => receiveUserById(res.data)))
    )
  );

export const createUser = (action$) =>
  action$.pipe(
    ofType(REQUESTED_CREATE_USER),
    map((action) => action.payload.user),
    mergeMap((user) =>
      postJSON(`/users/`, user).pipe(
        map((res) => receiveCreateUser(res.data)),
        catchError((error) =>
          of({
            type: REQUESTED_CREATE_USER_FAILED,
            payload: error.xhr.response,
            error: true,
          })
        )
      )
    )
  );

export const updateUser = (action$) =>
  action$.pipe(
    ofType(REQUESTED_UPDATE_USER),
    map((action) => action.payload.user),
    mergeMap((user) =>
      putJSON(`/users/${user.id}/`, user.user).pipe(
        map((res) => receiveUpdateUser(res.data)),
        catchError((error) =>
          of({
            type: REQUESTED_UPDATE_USER_FAILED,
            payload: error.xhr.response,
            error: true,
          })
        )
      )
    )
  );

export const deleteUser = (action$) =>
  action$.pipe(
    ofType(REQUESTED_DELETE_USER),
    map((action) => action.payload.user),
    switchMap((user) =>
      deleteJSON(`/users/${user.id}/`).pipe(
        map((res) => receiveDeleteUser(res.data))
      )
    )
  );
